import React from "react";
import { makeStyles } from "@mui/styles";
import { Box, Typography, IconButton } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { scroller } from "react-scroll";

const useStyles = makeStyles({
    root: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#cccccc",
        "& h4": {
            fontFamily: "Raleway",
            textTransform: "uppercase",
            marginTop: "60px",
        },
        "& h5": {
            fontFamily: "Raleway",
            textTransform: "uppercase",
            padding: "10px",
            textAlign: "center",
        },
    },
    divider: {
        width: "40px",
        border: 0,
    },
    expandButton: {
        marginTop: "20px",
        color: "#4a4a4a",
        zIndex: 2,
    },
});

export const About: React.FC = () => {
    const classes = useStyles();

    const handleExpandClick = () => {
        scroller.scrollTo("services", {
            duration: 1500,
            delay: 100,
            smooth: true,
        });
    };

    return (
        <Box id="about" className={classes.root}>
            <Box sx={{ width: "100%", backgroundColor: "#dedede", display: "flex", flexDirection: "column", alignItems: "center" }}>
                <Typography variant="h4" style={{ color: "#4a4a4a" }}>
                    About
                </Typography>
                <hr className={classes.divider} style={{ borderTop: "2px solid #653A96" }} />
                <Typography style={{ color: "#4a4a4a", padding: "20px", width: "50%", textAlign: "center" }}>
                    Sweep Safe certified
                </Typography>
            </Box>

            <Box sx={{ width: "70%", marginTop: "20px", display: "flex", flexDirection: "column", alignItems: "center" }}>
                <Typography variant="h5" style={{ color: "#4a4a4a", display: "flex" }}>
                    History
                </Typography>
                <Typography style={{ color: "#4a4a4a", padding: "20px", width: "70%", textAlign: "center" }}>
                    <i style={{ fontSize: "18px", fontFamily: "Raleway" }}>
                        Cleaning Chimneys in Waterford City and County since 1984.
                    </i>
                    <hr className={classes.divider} style={{ borderTop: "2px solid #4a4a4a" }} />
                    With over 31 years service with Waterford County Fire service
                </Typography>
            </Box>

            <IconButton className={classes.expandButton} onClick={handleExpandClick}>
                <ExpandMore fontSize="large" />
            </IconButton>
        </Box>
    );
};
